// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const finizen: PokeData = {
  "id": 963,
  "name": "finizen",
  "height": 13,
  "weight": 602,
  "base_experience": 63,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "supersonic",
    "mist",
    "water-gun",
    "hydro-pump",
    "focus-energy",
    "charm",
    "encore",
    "dive",
    "astonish",
    "aqua-tail",
    "aqua-jet",
    "double-hit",
    "acrobatics"
  ],
  "moves": [
    "supersonic",
    "hydro-pump",
    "aqua-tail",
    "aqua-jet",
    "acrobatics",
    "water-spout",
    "liquidation",
    "whirlpool",
    "rain-dance",
    "brine",
    "bubble",
    "aqua-cutter",
    "bubble-beam"
  ],
  "evolution_chain": {
    "id": 504,
    "item": null,
    "species": [
      {
        "name": "finizen",
        "order": 933,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "palafin",
        "order": 934,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 963,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 38,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.OTHER
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 55,
    "speed": 75,
    "ability_power": 45
  },
  "stat_changes": [],
  "catch_rate": 200,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
